import React from "react";

var TSpan = function (props) {
  return React.createElement("tspan", props);
};

export default TSpan;